module.exports = __webpack_public_path__ + "static/img/app4.f687377.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/app4.jpg
// module id = 9qSy
// module chunks = 1